(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mega-hover-dropdown"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
  const megaHover = document.querySelector('.mega-hover');
  const stickyMenu = document.querySelector('.mega-hover-wrapper-container');

  if (!megaHover || !stickyMenu) return;

  const triggers = megaHover.querySelectorAll('.mega-hover__trigger[data-panel-target]');
  const panels = megaHover.querySelectorAll('.mega-hover__panel');

  function closeAllPanels() {
    triggers.forEach(trigger => trigger.classList.remove('active'));
    panels.forEach(panel => panel.classList.remove('active'));
  }

  triggers.forEach((trigger) => {
    trigger.addEventListener('mouseenter', () => {
      const target = trigger.getAttribute('data-panel-target');

      closeAllPanels();
      trigger.classList.add('active');

      const panel = megaHover.querySelector(`.mega-hover__panel[data-panel="${target}"]`);
      if (panel) {
        panel.classList.add('active');
      }
    });
  });

  megaHover.addEventListener('mouseleave', () => {
    closeAllPanels();
  });

  let lastScrollTop = window.pageYOffset || document.documentElement.scrollTop;

  window.addEventListener('scroll', function () {
    const currentScroll = window.pageYOffset || document.documentElement.scrollTop;

    if (currentScroll <= 100) {
      stickyMenu.classList.remove('is-sticky-up', 'is-hidden-down');
      return;
    }

    if (currentScroll < lastScrollTop) {
      stickyMenu.classList.add('is-sticky-up');
      stickyMenu.classList.remove('is-hidden-down');
    } else {
      stickyMenu.classList.add('is-hidden-down');
    }

    lastScrollTop = currentScroll <= 0 ? 0 : currentScroll;
  });
});

document.addEventListener('DOMContentLoaded', function () {
  const megaHover = document.querySelector('.mega-hover');
  const stickyMenu = document.querySelector('.mega-hover-wrapper-container');

  if (!megaHover || !stickyMenu) return;

  const triggers = megaHover.querySelectorAll(
    '.mega-hover__trigger[data-panel-target]'
  );
  const panels = megaHover.querySelectorAll('.mega-hover__panel');

  function closeAllPanels() {
    triggers.forEach(trigger => trigger.classList.remove('active'));
    panels.forEach(panel => panel.classList.remove('active'));
  }

  triggers.forEach(trigger => {
    trigger.addEventListener('mouseenter', function () {
      const target = trigger.getAttribute('data-panel-target');

      closeAllPanels();
      trigger.classList.add('active');

      const panel = megaHover.querySelector(
        `.mega-hover__panel[data-panel="${target}"]`
      );

      if (panel) {
        panel.classList.add('active');
      }
    });
  });

  megaHover.addEventListener('mouseleave', closeAllPanels);

  window.addEventListener('scroll', function () {
    const currentScroll =
      window.pageYOffset || document.documentElement.scrollTop;

    if (currentScroll > 100) {
      stickyMenu.classList.add('is-sticky-up');
    } else {
      stickyMenu.classList.remove('is-sticky-up');
    }
  });
});

  } catch(e) { console.error(e); }
})();
})();
